module.exports = __webpack_public_path__ + "img/housee.56dff493.png";